export default __webpack_public_path__ + "static/media/deatheater.01c8b704.png";